import qe from "react";
import le, { css as T, createGlobalStyle as $r } from "styled-components";
var de = { exports: {} }, M = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var De;
function _r() {
  if (De)
    return M;
  De = 1;
  var r = qe, t = Symbol.for("react.element"), o = Symbol.for("react.fragment"), l = Object.prototype.hasOwnProperty, s = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, d = { key: !0, ref: !0, __self: !0, __source: !0 };
  function m(y, p, k) {
    var g, w = {}, x = null, I = null;
    k !== void 0 && (x = "" + k), p.key !== void 0 && (x = "" + p.key), p.ref !== void 0 && (I = p.ref);
    for (g in p)
      l.call(p, g) && !d.hasOwnProperty(g) && (w[g] = p[g]);
    if (y && y.defaultProps)
      for (g in p = y.defaultProps, p)
        w[g] === void 0 && (w[g] = p[g]);
    return { $$typeof: t, type: y, key: x, ref: I, props: w, _owner: s.current };
  }
  return M.Fragment = o, M.jsx = m, M.jsxs = m, M;
}
var B = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Me;
function Ir() {
  return Me || (Me = 1, process.env.NODE_ENV !== "production" && function() {
    var r = qe, t = Symbol.for("react.element"), o = Symbol.for("react.portal"), l = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), d = Symbol.for("react.profiler"), m = Symbol.for("react.provider"), y = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), k = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), I = Symbol.for("react.offscreen"), Y = Symbol.iterator, Z = "@@iterator";
    function N(e) {
      if (e === null || typeof e != "object")
        return null;
      var a = Y && e[Y] || e[Z];
      return typeof a == "function" ? a : null;
    }
    var S = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(e) {
      {
        for (var a = arguments.length, n = new Array(a > 1 ? a - 1 : 0), i = 1; i < a; i++)
          n[i - 1] = arguments[i];
        He("error", e, n);
      }
    }
    function He(e, a, n) {
      {
        var i = S.ReactDebugCurrentFrame, c = i.getStackAddendum();
        c !== "" && (a += "%s", n = n.concat([c]));
        var b = n.map(function(u) {
          return String(u);
        });
        b.unshift("Warning: " + a), Function.prototype.apply.call(console[e], console, b);
      }
    }
    var Je = !1, Ke = !1, Xe = !1, Qe = !1, Ze = !1, er = Symbol.for("react.module.reference");
    function rr(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === l || e === d || Ze || e === s || e === k || e === g || Qe || e === I || Je || Ke || Xe || typeof e == "object" && e !== null && (e.$$typeof === x || e.$$typeof === w || e.$$typeof === m || e.$$typeof === y || e.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === er || e.getModuleId !== void 0));
    }
    function tr(e, a, n) {
      var i = e.displayName;
      if (i)
        return i;
      var c = a.displayName || a.name || "";
      return c !== "" ? n + "(" + c + ")" : n;
    }
    function pe(e) {
      return e.displayName || "Context";
    }
    function P(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case l:
          return "Fragment";
        case o:
          return "Portal";
        case d:
          return "Profiler";
        case s:
          return "StrictMode";
        case k:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case y:
            var a = e;
            return pe(a) + ".Consumer";
          case m:
            var n = e;
            return pe(n._context) + ".Provider";
          case p:
            return tr(e, e.render, "ForwardRef");
          case w:
            var i = e.displayName || null;
            return i !== null ? i : P(e.type) || "Memo";
          case x: {
            var c = e, b = c._payload, u = c._init;
            try {
              return P(u(b));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var W = Object.assign, A = 0, he, ge, ve, ye, we, xe, Re;
    function Ce() {
    }
    Ce.__reactDisabledLog = !0;
    function ar() {
      {
        if (A === 0) {
          he = console.log, ge = console.info, ve = console.warn, ye = console.error, we = console.group, xe = console.groupCollapsed, Re = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        A++;
      }
    }
    function nr() {
      {
        if (A--, A === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: W({}, e, {
              value: he
            }),
            info: W({}, e, {
              value: ge
            }),
            warn: W({}, e, {
              value: ve
            }),
            error: W({}, e, {
              value: ye
            }),
            group: W({}, e, {
              value: we
            }),
            groupCollapsed: W({}, e, {
              value: xe
            }),
            groupEnd: W({}, e, {
              value: Re
            })
          });
        }
        A < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ee = S.ReactCurrentDispatcher, re;
    function q(e, a, n) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (c) {
            var i = c.stack.trim().match(/\n( *(at )?)/);
            re = i && i[1] || "";
          }
        return `
` + re + e;
      }
    }
    var te = !1, U;
    {
      var or = typeof WeakMap == "function" ? WeakMap : Map;
      U = new or();
    }
    function ke(e, a) {
      if (!e || te)
        return "";
      {
        var n = U.get(e);
        if (n !== void 0)
          return n;
      }
      var i;
      te = !0;
      var c = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var b;
      b = ee.current, ee.current = null, ar();
      try {
        if (a) {
          var u = function() {
            throw Error();
          };
          if (Object.defineProperty(u.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(u, []);
            } catch ($) {
              i = $;
            }
            Reflect.construct(e, [], u);
          } else {
            try {
              u.call();
            } catch ($) {
              i = $;
            }
            e.call(u.prototype);
          }
        } else {
          try {
            throw Error();
          } catch ($) {
            i = $;
          }
          e();
        }
      } catch ($) {
        if ($ && i && typeof $.stack == "string") {
          for (var f = $.stack.split(`
`), C = i.stack.split(`
`), h = f.length - 1, v = C.length - 1; h >= 1 && v >= 0 && f[h] !== C[v]; )
            v--;
          for (; h >= 1 && v >= 0; h--, v--)
            if (f[h] !== C[v]) {
              if (h !== 1 || v !== 1)
                do
                  if (h--, v--, v < 0 || f[h] !== C[v]) {
                    var E = `
` + f[h].replace(" at new ", " at ");
                    return e.displayName && E.includes("<anonymous>") && (E = E.replace("<anonymous>", e.displayName)), typeof e == "function" && U.set(e, E), E;
                  }
                while (h >= 1 && v >= 0);
              break;
            }
        }
      } finally {
        te = !1, ee.current = b, nr(), Error.prepareStackTrace = c;
      }
      var j = e ? e.displayName || e.name : "", Ae = j ? q(j) : "";
      return typeof e == "function" && U.set(e, Ae), Ae;
    }
    function ir(e, a, n) {
      return ke(e, !1);
    }
    function sr(e) {
      var a = e.prototype;
      return !!(a && a.isReactComponent);
    }
    function V(e, a, n) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return ke(e, sr(e));
      if (typeof e == "string")
        return q(e);
      switch (e) {
        case k:
          return q("Suspense");
        case g:
          return q("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case p:
            return ir(e.render);
          case w:
            return V(e.type, a, n);
          case x: {
            var i = e, c = i._payload, b = i._init;
            try {
              return V(b(c), a, n);
            } catch {
            }
          }
        }
      return "";
    }
    var G = Object.prototype.hasOwnProperty, Ee = {}, Se = S.ReactDebugCurrentFrame;
    function H(e) {
      if (e) {
        var a = e._owner, n = V(e.type, e._source, a ? a.type : null);
        Se.setExtraStackFrame(n);
      } else
        Se.setExtraStackFrame(null);
    }
    function lr(e, a, n, i, c) {
      {
        var b = Function.call.bind(G);
        for (var u in e)
          if (b(e, u)) {
            var f = void 0;
            try {
              if (typeof e[u] != "function") {
                var C = Error((i || "React class") + ": " + n + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw C.name = "Invariant Violation", C;
              }
              f = e[u](a, u, i, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (h) {
              f = h;
            }
            f && !(f instanceof Error) && (H(c), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", i || "React class", n, u, typeof f), H(null)), f instanceof Error && !(f.message in Ee) && (Ee[f.message] = !0, H(c), R("Failed %s type: %s", n, f.message), H(null));
          }
      }
    }
    var fr = Array.isArray;
    function ae(e) {
      return fr(e);
    }
    function ur(e) {
      {
        var a = typeof Symbol == "function" && Symbol.toStringTag, n = a && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return n;
      }
    }
    function cr(e) {
      try {
        return Pe(e), !1;
      } catch {
        return !0;
      }
    }
    function Pe(e) {
      return "" + e;
    }
    function $e(e) {
      if (cr(e))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ur(e)), Pe(e);
    }
    var D = S.ReactCurrentOwner, dr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Ie, ne;
    ne = {};
    function mr(e) {
      if (G.call(e, "ref")) {
        var a = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (a && a.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function br(e) {
      if (G.call(e, "key")) {
        var a = Object.getOwnPropertyDescriptor(e, "key").get;
        if (a && a.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function pr(e, a) {
      if (typeof e.ref == "string" && D.current && a && D.current.stateNode !== a) {
        var n = P(D.current.type);
        ne[n] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', P(D.current.type), e.ref), ne[n] = !0);
      }
    }
    function hr(e, a) {
      {
        var n = function() {
          _e || (_e = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: n,
          configurable: !0
        });
      }
    }
    function gr(e, a) {
      {
        var n = function() {
          Ie || (Ie = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: n,
          configurable: !0
        });
      }
    }
    var vr = function(e, a, n, i, c, b, u) {
      var f = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: a,
        ref: n,
        props: u,
        // Record the component responsible for creating this element.
        _owner: b
      };
      return f._store = {}, Object.defineProperty(f._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(f, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.defineProperty(f, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: c
      }), Object.freeze && (Object.freeze(f.props), Object.freeze(f)), f;
    };
    function yr(e, a, n, i, c) {
      {
        var b, u = {}, f = null, C = null;
        n !== void 0 && ($e(n), f = "" + n), br(a) && ($e(a.key), f = "" + a.key), mr(a) && (C = a.ref, pr(a, c));
        for (b in a)
          G.call(a, b) && !dr.hasOwnProperty(b) && (u[b] = a[b]);
        if (e && e.defaultProps) {
          var h = e.defaultProps;
          for (b in h)
            u[b] === void 0 && (u[b] = h[b]);
        }
        if (f || C) {
          var v = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          f && hr(u, v), C && gr(u, v);
        }
        return vr(e, f, C, c, i, D.current, u);
      }
    }
    var oe = S.ReactCurrentOwner, Te = S.ReactDebugCurrentFrame;
    function O(e) {
      if (e) {
        var a = e._owner, n = V(e.type, e._source, a ? a.type : null);
        Te.setExtraStackFrame(n);
      } else
        Te.setExtraStackFrame(null);
    }
    var ie;
    ie = !1;
    function se(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function We() {
      {
        if (oe.current) {
          var e = P(oe.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function wr(e) {
      {
        if (e !== void 0) {
          var a = e.fileName.replace(/^.*[\\\/]/, ""), n = e.lineNumber;
          return `

Check your code at ` + a + ":" + n + ".";
        }
        return "";
      }
    }
    var Oe = {};
    function xr(e) {
      {
        var a = We();
        if (!a) {
          var n = typeof e == "string" ? e : e.displayName || e.name;
          n && (a = `

Check the top-level render call using <` + n + ">.");
        }
        return a;
      }
    }
    function je(e, a) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var n = xr(a);
        if (Oe[n])
          return;
        Oe[n] = !0;
        var i = "";
        e && e._owner && e._owner !== oe.current && (i = " It was passed a child from " + P(e._owner.type) + "."), O(e), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, i), O(null);
      }
    }
    function Fe(e, a) {
      {
        if (typeof e != "object")
          return;
        if (ae(e))
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            se(i) && je(i, a);
          }
        else if (se(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var c = N(e);
          if (typeof c == "function" && c !== e.entries)
            for (var b = c.call(e), u; !(u = b.next()).done; )
              se(u.value) && je(u.value, a);
        }
      }
    }
    function Rr(e) {
      {
        var a = e.type;
        if (a == null || typeof a == "string")
          return;
        var n;
        if (typeof a == "function")
          n = a.propTypes;
        else if (typeof a == "object" && (a.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        a.$$typeof === w))
          n = a.propTypes;
        else
          return;
        if (n) {
          var i = P(a);
          lr(n, e.props, "prop", i, e);
        } else if (a.PropTypes !== void 0 && !ie) {
          ie = !0;
          var c = P(a);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", c || "Unknown");
        }
        typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Cr(e) {
      {
        for (var a = Object.keys(e.props), n = 0; n < a.length; n++) {
          var i = a[n];
          if (i !== "children" && i !== "key") {
            O(e), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", i), O(null);
            break;
          }
        }
        e.ref !== null && (O(e), R("Invalid attribute `ref` supplied to `React.Fragment`."), O(null));
      }
    }
    function ze(e, a, n, i, c, b) {
      {
        var u = rr(e);
        if (!u) {
          var f = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (f += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var C = wr(c);
          C ? f += C : f += We();
          var h;
          e === null ? h = "null" : ae(e) ? h = "array" : e !== void 0 && e.$$typeof === t ? (h = "<" + (P(e.type) || "Unknown") + " />", f = " Did you accidentally export a JSX literal instead of a component?") : h = typeof e, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", h, f);
        }
        var v = yr(e, a, n, c, b);
        if (v == null)
          return v;
        if (u) {
          var E = a.children;
          if (E !== void 0)
            if (i)
              if (ae(E)) {
                for (var j = 0; j < E.length; j++)
                  Fe(E[j], e);
                Object.freeze && Object.freeze(E);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Fe(E, e);
        }
        return e === l ? Cr(v) : Rr(v), v;
      }
    }
    function kr(e, a, n) {
      return ze(e, a, n, !0);
    }
    function Er(e, a, n) {
      return ze(e, a, n, !1);
    }
    var Sr = Er, Pr = kr;
    B.Fragment = l, B.jsx = Sr, B.jsxs = Pr;
  }()), B;
}
process.env.NODE_ENV === "production" ? de.exports = _r() : de.exports = Ir();
var mt = de.exports;
const X = 1e4;
function Q(r) {
  return 1 - (1 - r) ** 1.685;
}
function Tr(r) {
  const t = Q(r / 100), o = t === 0 ? 1 / X : t;
  return `${r}% { transform: scaleY(${o}); }`;
}
function Wr(r) {
  const t = Q(r / 100), o = t === 0 ? X : 1 / t;
  return `${r}% { transform: scaleY(${o}); }`;
}
function Or(r) {
  const t = Q(1 - r / 100), o = t === 0 ? 1 / X : t;
  return `${r}% { transform: scaleY(${o}); }`;
}
function jr(r) {
  const t = Q(1 - r / 100), o = t === 0 ? X : 1 / t;
  return `${r}% { transform: scaleY(${o}); }`;
}
`${[
  ...new Array(101).keys()
].map(Tr).join(" ")}${[
  ...new Array(101).keys()
].map(Or).join(" ")}`;
`${[
  ...new Array(101).keys()
].map(Wr).join(" ")}${[
  ...new Array(101).keys()
].map(jr).join(" ")}`;
function Fr(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function L(r, t) {
  return L = Object.setPrototypeOf || function(o, l) {
    return o.__proto__ = l, o;
  }, L(r, t);
}
function zr(r, t) {
  r.prototype = Object.create(t.prototype), r.prototype.constructor = r, L(r, t);
}
function me(r) {
  return me = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, me(r);
}
function Ar(r) {
  return Function.toString.call(r).indexOf("[native code]") !== -1;
}
function Dr() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function J(r, t, o) {
  return Dr() ? J = Reflect.construct : J = function(l, s, d) {
    var m = [null];
    m.push.apply(m, s);
    var y = Function.bind.apply(l, m), p = new y();
    return d && L(p, d.prototype), p;
  }, J.apply(null, arguments);
}
function be(r) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return be = function(o) {
    if (o === null || !Ar(o))
      return o;
    if (typeof o != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(o))
        return t.get(o);
      t.set(o, l);
    }
    function l() {
      return J(o, arguments, me(this).constructor);
    }
    return l.prototype = Object.create(o.prototype, {
      constructor: {
        value: l,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), L(l, o);
  }, be(r);
}
var Mr = {
  1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
  2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
  3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
  4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
  5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
  6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
  7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
  8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
  9: `Please provide a number of steps to the modularScale helper.

`,
  10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
  12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
  13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
  14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  16: `You must provide a template to this method.

`,
  17: `You passed an unsupported selector state to this method.

`,
  18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  23: `fontFace expects a name of a font-family.

`,
  24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  25: `fontFace expects localFonts to be an array.

`,
  26: `fontFace expects fileFormats to be an array.

`,
  27: `radialGradient requries at least 2 color-stops to properly render.

`,
  28: `Please supply a filename to retinaImage() as the first argument.

`,
  29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
  32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
  33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
  34: `borderRadius expects a radius value as a string or number as the second argument.

`,
  35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  36: `Property must be a string value.

`,
  37: `Syntax Error at %s.

`,
  38: `Formula contains a function that needs parentheses at %s.

`,
  39: `Formula is missing closing parenthesis at %s.

`,
  40: `Formula has too many closing parentheses at %s.

`,
  41: `All values in a formula must have the same unit or be unitless.

`,
  42: `Please provide a number of steps to the modularScale helper.

`,
  43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
  45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
  46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
  47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
  51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
  52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  53: `fontFace expects localFonts to be an array.

`,
  54: `fontFace expects fileFormats to be an array.

`,
  55: `fontFace expects a name of a font-family.

`,
  56: `linearGradient requries at least 2 color-stops to properly render.

`,
  57: `radialGradient requries at least 2 color-stops to properly render.

`,
  58: `Please supply a filename to retinaImage() as the first argument.

`,
  59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  61: `Property must be a string value.

`,
  62: `borderRadius expects a radius value as a string or number as the second argument.

`,
  63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
  65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
  66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
  67: `You must provide a template to this method.

`,
  68: `You passed an unsupported selector state to this method.

`,
  69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
  70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
  71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
  72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
  73: `Please provide a valid CSS variable.

`,
  74: `CSS variable not found and no default was provided.

`,
  75: `important requires a valid style object, got a %s instead.

`,
  76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
  77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
  78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function Br() {
  for (var r = arguments.length, t = new Array(r), o = 0; o < r; o++)
    t[o] = arguments[o];
  var l = t[0], s = [], d;
  for (d = 1; d < t.length; d += 1)
    s.push(t[d]);
  return s.forEach(function(m) {
    l = l.replace(/%[a-z]/, m);
  }), l;
}
var z = /* @__PURE__ */ function(r) {
  zr(t, r);
  function t(o) {
    var l;
    if (process.env.NODE_ENV === "production")
      l = r.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + o + " for more information.") || this;
    else {
      for (var s = arguments.length, d = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
        d[m - 1] = arguments[m];
      l = r.call(this, Br.apply(void 0, [Mr[o]].concat(d))) || this;
    }
    return Fr(l);
  }
  return t;
}(/* @__PURE__ */ be(Error));
function fe(r) {
  return Math.round(r * 255);
}
function Lr(r, t, o) {
  return fe(r) + "," + fe(t) + "," + fe(o);
}
function Be(r, t, o, l) {
  if (l === void 0 && (l = Lr), t === 0)
    return l(o, o, o);
  var s = (r % 360 + 360) % 360 / 60, d = (1 - Math.abs(2 * o - 1)) * t, m = d * (1 - Math.abs(s % 2 - 1)), y = 0, p = 0, k = 0;
  s >= 0 && s < 1 ? (y = d, p = m) : s >= 1 && s < 2 ? (y = m, p = d) : s >= 2 && s < 3 ? (p = d, k = m) : s >= 3 && s < 4 ? (p = m, k = d) : s >= 4 && s < 5 ? (y = m, k = d) : s >= 5 && s < 6 && (y = d, k = m);
  var g = o - d / 2, w = y + g, x = p + g, I = k + g;
  return l(w, x, I);
}
var Le = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function Yr(r) {
  if (typeof r != "string")
    return r;
  var t = r.toLowerCase();
  return Le[t] ? "#" + Le[t] : r;
}
var Nr = /^#[a-fA-F0-9]{6}$/, qr = /^#[a-fA-F0-9]{8}$/, Ur = /^#[a-fA-F0-9]{3}$/, Vr = /^#[a-fA-F0-9]{4}$/, ue = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i, Gr = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i, Hr = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, Jr = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
function Kr(r) {
  if (typeof r != "string")
    throw new z(3);
  var t = Yr(r);
  if (t.match(Nr))
    return {
      red: parseInt("" + t[1] + t[2], 16),
      green: parseInt("" + t[3] + t[4], 16),
      blue: parseInt("" + t[5] + t[6], 16)
    };
  if (t.match(qr)) {
    var o = parseFloat((parseInt("" + t[7] + t[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + t[1] + t[2], 16),
      green: parseInt("" + t[3] + t[4], 16),
      blue: parseInt("" + t[5] + t[6], 16),
      alpha: o
    };
  }
  if (t.match(Ur))
    return {
      red: parseInt("" + t[1] + t[1], 16),
      green: parseInt("" + t[2] + t[2], 16),
      blue: parseInt("" + t[3] + t[3], 16)
    };
  if (t.match(Vr)) {
    var l = parseFloat((parseInt("" + t[4] + t[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + t[1] + t[1], 16),
      green: parseInt("" + t[2] + t[2], 16),
      blue: parseInt("" + t[3] + t[3], 16),
      alpha: l
    };
  }
  var s = ue.exec(t);
  if (s)
    return {
      red: parseInt("" + s[1], 10),
      green: parseInt("" + s[2], 10),
      blue: parseInt("" + s[3], 10)
    };
  var d = Gr.exec(t.substring(0, 50));
  if (d)
    return {
      red: parseInt("" + d[1], 10),
      green: parseInt("" + d[2], 10),
      blue: parseInt("" + d[3], 10),
      alpha: parseFloat("" + d[4])
    };
  var m = Hr.exec(t);
  if (m) {
    var y = parseInt("" + m[1], 10), p = parseInt("" + m[2], 10) / 100, k = parseInt("" + m[3], 10) / 100, g = "rgb(" + Be(y, p, k) + ")", w = ue.exec(g);
    if (!w)
      throw new z(4, t, g);
    return {
      red: parseInt("" + w[1], 10),
      green: parseInt("" + w[2], 10),
      blue: parseInt("" + w[3], 10)
    };
  }
  var x = Jr.exec(t.substring(0, 50));
  if (x) {
    var I = parseInt("" + x[1], 10), Y = parseInt("" + x[2], 10) / 100, Z = parseInt("" + x[3], 10) / 100, N = "rgb(" + Be(I, Y, Z) + ")", S = ue.exec(N);
    if (!S)
      throw new z(4, t, N);
    return {
      red: parseInt("" + S[1], 10),
      green: parseInt("" + S[2], 10),
      blue: parseInt("" + S[3], 10),
      alpha: parseFloat("" + x[4])
    };
  }
  throw new z(5);
}
var Ye = function(r) {
  return r.length === 7 && r[1] === r[2] && r[3] === r[4] && r[5] === r[6] ? "#" + r[1] + r[3] + r[5] : r;
};
function F(r) {
  var t = r.toString(16);
  return t.length === 1 ? "0" + t : t;
}
function Ne(r, t, o) {
  if (typeof r == "number" && typeof t == "number" && typeof o == "number")
    return Ye("#" + F(r) + F(t) + F(o));
  if (typeof r == "object" && t === void 0 && o === void 0)
    return Ye("#" + F(r.red) + F(r.green) + F(r.blue));
  throw new z(6);
}
function ce(r, t, o, l) {
  if (typeof r == "string" && typeof t == "number") {
    var s = Kr(r);
    return "rgba(" + s.red + "," + s.green + "," + s.blue + "," + t + ")";
  } else {
    if (typeof r == "number" && typeof t == "number" && typeof o == "number" && typeof l == "number")
      return l >= 1 ? Ne(r, t, o) : "rgba(" + r + "," + t + "," + o + "," + l + ")";
    if (typeof r == "object" && t === void 0 && o === void 0 && l === void 0)
      return r.alpha >= 1 ? Ne(r.red, r.green, r.blue) : "rgba(" + r.red + "," + r.green + "," + r.blue + "," + r.alpha + ")";
  }
  throw new z(7);
}
const Xr = typeof le == "function" ? le : le.default, bt = Xr, pt = T`
  @keyframes ripple {
    0% {
      box-shadow: 0px 0px 0px 1px ${(r) => ce(r.theme.colors.interface, 0)};
    }
    50% {
      box-shadow: 0px 0px 0px 15px ${(r) => ce(r.theme.colors.interface, 0.1)};
    }
    100% {
      box-shadow: 0px 0px 0px 15px ${(r) => ce(r.theme.colors.interface, 0)};
    }
  }
  animation: ripple 0.3s linear forwards;
`, Ue = 1440, Qr = Ue - 1, Ve = 1024, Zr = Ve - 1, Ge = 768, et = Ge - 1, K = {
  sm: {
    minScreenWidth: 0,
    maxScreenWidth: et,
    maxContainerWidth: void 0,
    margin: 16,
    gutter: 16
  },
  md: {
    minScreenWidth: Ge,
    maxScreenWidth: Zr,
    maxContainerWidth: 608,
    margin: 32,
    gutter: 16
  },
  lg: {
    minScreenWidth: Ve,
    maxScreenWidth: Qr,
    maxContainerWidth: void 0,
    margin: 32,
    gutter: 24
  },
  xl: {
    minScreenWidth: Ue,
    maxScreenWidth: Number.POSITIVE_INFINITY,
    maxContainerWidth: 1312,
    margin: 64,
    gutter: 32
  }
};
T`
  user-select: none;
  -webkit-tap-highlight-color: transparent;
`;
T`
  -webkit-mask-image: -webkit-radial-gradient(white, black);
`;
const ht = T`
  touch-action: manipulation;
`, gt = T`
  background: none;
  border: none;
  display: inline-block;
  font: inherit;
  margin: 0;
  padding: 0;
  &::-moz-focus-inner {
    border: none;
    padding: 0;
  }
`;
function vt({ top: r = "0px", right: t = "0px", bottom: o = "0px", left: l = "0px", position: s = "absolute" } = {}) {
  return T`
    position: ${s};
    top: ${r};
    left: ${l};
    right: ${t};
    bottom: ${o};
  `;
}
T`
  outline: 2px solid #7aacfe; /* for non-webkit browsers */
  outline: 5px auto -webkit-focus-ring-color;
`;
const rt = T`
  /* normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */

  /* Document
   ========================================================================== */

  /**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

  html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }

  /* Sections
   ========================================================================== */

  /**
 * Remove the margin in all browsers.
 */

  body {
    margin: 0;
  }

  /**
 * Correct the font size and margin on 'h1' elements within 'section' and
 * 'article' contexts in Chrome, Firefox, and Safari.
 */

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  /* Grouping content
   ========================================================================== */

  /**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  /**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd 'em' font sizing in all browsers.
 */

  pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /* Text-level semantics
   ========================================================================== */

  /**
 * Remove the gray background on active links in IE 10.
 */

  a {
    background-color: transparent;
  }

  /**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

  abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
  }

  /**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

  b,
  strong {
    font-weight: bolder;
  }

  /**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd 'em' font sizing in all browsers.
 */

  code,
  kbd,
  samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /**
 * Add the correct font size in all browsers.
 */

  small {
    font-size: 80%;
  }

  /**
 * Prevent 'sub' and 'sup' elements from affecting the line height in
 * all browsers.
 */

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /* Embedded content
   ========================================================================== */

  /**
 * Remove the border on images inside links in IE 10.
 */

  img {
    border-style: none;
  }

  /* Forms
   ========================================================================== */

  /**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
  }

  /**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

  button,
  input {
    /* 1 */
    overflow: visible;
  }

  /**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
 * Correct the inability to style clickable types in iOS and Safari.
 */

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  /**
 * Remove the inner border and padding in Firefox.
 */

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
 * Restore the focus styles unset by the previous rule.
 */

  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
 * Correct the padding in Firefox.
 */

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  /**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from 'fieldset' elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    'fieldset' elements in all browsers.
 */

  legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }

  /**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

  progress {
    vertical-align: baseline;
  }

  /**
 * Remove the default vertical scrollbar in IE 10+.
 */

  textarea {
    overflow: auto;
  }

  /**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */

  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  /**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  /**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

  [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  /**
 * Remove the inner padding in Chrome and Safari on macOS.
 */

  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to 'inherit' in Safari.
 */

  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  /* Interactive
   ========================================================================== */

  /*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */

  details {
    display: block;
  }

  /*
 * Add the correct display in all browsers.
 */

  summary {
    display: list-item;
  }

  /* Misc
   ========================================================================== */

  /**
 * Add the correct display in IE 10+.
 */

  template {
    display: none;
  }

  /**
 * Add the correct display in IE 10.
 */

  [hidden] {
    display: none;
  }
`, yt = "#ffffff", wt = "#000000", xt = "#fafafa", Rt = "#c4c4c4", Ct = "#e02d21", kt = "#dfdfdf", Et = "#606060", St = "#dfdfdf", Pt = "#091652", tt = "Calibre-R ,sans-serif", at = "1.25rem", nt = "1.75rem", ot = "2.188rem", it = "2.5rem", st = "2.812rem", _ = `
  font-family: ${tt};
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
`, $t = () => `${_}
    font-size: ${st};
    line-height: 1.07;
    letter-spacing: -0.3px;`, _t = () => `${_}
    font-size: ${it};
    line-height: 1;
    letter-spacing: -1px;`, It = () => `${_}
    font-size: ${ot};
    line-height: 1.14;
    letter-spacing: normal;`, Tt = () => `${_}
    font-size: ${nt};
    line-height: 1.25;
    letter-spacing: normal;`, Wt = () => `${_}
    font-size: ${at};
    line-height: 1.2;
    letter-spacing: normal;`, Ot = () => `${_}
    font-size: 12px;
    line-height: 1.67;
    letter-spacing: normal;`, jt = () => `${_}
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: normal;`, Ft = () => `${_}
    font-size: 10px;
    line-height: 1.2;
    letter-spacing: normal;`, zt = () => `${_}
    font-size: 14px;
    line-height: 1.375;
    letter-spacing: normal;`, lt = {
  aria: {
    brandPrimaryColor: "#002b49"
  },
  beaurivage: {
    brandPrimaryColor: "#2664ac"
  },
  bellagio: {
    brandPrimaryColor: "#005b70"
  },
  borgata: {
    brandPrimaryColor: "#3f2767"
  },
  delanolasvegas: {
    brandPrimaryColor: "#7e8083"
  },
  empirecitycasino: {
    brandPrimaryColor: "#000000",
    interfacePrimaryColor: "#1c1b1c"
  },
  excalibur: {
    brandPrimaryColor: "#572d2d"
  },
  goldstrike: {
    brandPrimaryColor: "#333"
  },
  luxor: {
    brandPrimaryColor: "#007b8e"
  },
  mandalaybay: {
    brandPrimaryColor: "#e6b135",
    interfacePrimaryColor: "#556b8a"
  },
  mgmgrand: {
    brandPrimaryColor: "#716443"
  },
  mgmgranddetroit: {
    brandPrimaryColor: "#84724d"
  },
  mgmnationalharbor: {
    brandPrimaryColor: "#082437"
  },
  mgmnorthfieldpark: {
    brandPrimaryColor: "#0c3246",
    interfacePrimaryColor: "#1c1b1c"
  },
  mgmspringfield: {
    brandPrimaryColor: "#3f6c7d"
  },
  mgmresorts: {
    brandPrimaryColor: "#996d15",
    interfacePrimaryColor: "#4957f4"
  },
  mirage: {
    brandPrimaryColor: "#17586d"
  },
  newyorknewyork: {
    brandPrimaryColor: "#024f80"
  },
  nomadlasvegas: {
    brandPrimaryColor: "#612141"
  },
  parkmgm: {
    brandPrimaryColor: "#5b794c"
  },
  signaturemgmgrand: {
    brandPrimaryColor: "#695a3d"
  },
  vdara: {
    brandPrimaryColor: "#71655f"
  },
  cosmopolitanlasvegas: {
    brandPrimaryColor: "#612c73"
  },
  wlasvegas: {
    brandPrimaryColor: "#000000"
  }
}, ft = {
  buttonTransitionDuration: "0.3s",
  buttonTransitionTimingFn: "ease-in-out",
  mobileNavigationHeight: 52,
  desktopNavigationHeight: 76,
  tabletFixedButtonHeight: 66,
  desktopFixedButtonHeight: 82,
  space: [],
  breakpoints: [
    `${K.md.minScreenWidth}px`,
    `${K.lg.minScreenWidth}px`,
    `${K.xl.minScreenWidth}px`
  ]
}, ut = {
  black: "#000",
  darkestGrey: "#404040",
  darkGrey: "#606060",
  grey: "#7f7f7f",
  lightGrey: "#bfbfbf",
  disabledGrey: "#dfdfdf",
  lightestGrey: "#f8f8f8",
  white: "#fff",
  errorRed: "#e02d21",
  darkGrey1: "#747474",
  outlineColor: "#091652"
};
function At(r) {
  const { brandPrimaryColor: t, interfacePrimaryColor: o } = lt[r];
  return {
    ...ft,
    colors: {
      brand: t,
      interface: o || t,
      ...ut
    }
  };
}
$r`
${rt}

* {
  box-sizing: border-box;
}

html {
  /* ios opera momentum scrolling */
  -webkit-overflow-scrolling: touch;
}

body {
  min-height: 100vh;
  padding: 0;
  margin: 0;
  background-color: #fff;

  font-family: 'Calibre-R', sans-serif;
  font-size: 16px;
  line-height: 1.25em;
  color: #606060;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* ios safari momentum scrolling */
  -webkit-overflow-scrolling: touch;
}

h1,
h2,
h3,
h4,
h5,
h6,
blockquote {
  margin: 0;
}

/* no outline for non-keyboard-inputs elements */
*:focus {
  outline-offset: 0;
  outline-width: 0;
}

@media screen and (max-width: ${K.sm.maxScreenWidth}px) {
  input, textarea {
    font-size: 16px;
  }
}

${({ assetsBaseURL: r = "https://static.mgmresorts.com/content/dam/MGM/direct/vega/fonts" }) => `
  /* thin */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 100;
    font-style: normal;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-Thin.eot?#iefix');
    src: url('${r}/Calibre-RWeb-Thin.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-Thin.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-Thin.woff') format('woff');
  }

  /* thin italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 100;
    font-style: italic;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-ThinItalic.eot?#iefix');
    src: url('${r}/Calibre-RWeb-ThinItalic.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-ThinItalic.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-ThinItalic.woff') format('woff');
  }

  /* light */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 300;
    font-style: normal;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-Light.eot?#iefix');
    src: url('${r}/Calibre-RWeb-Light.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-Light.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-Light.woff') format('woff');
  }

  /* light italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 300;
    font-style: italic;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-LightItalic.eot?#iefix');
    src: url('${r}/Calibre-RWeb-LightItalic.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-LightItalic.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-LightItalic.woff') format('woff');
  }

  /* regular */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 400;
    font-style: normal;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-Regular.eot?#iefix');
    src: url('${r}/Calibre-RWeb-Regular.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-Regular.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-Regular.woff') format('woff');
  }

  /* regular italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 400;
    font-style: italic;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-RegularItalic.eot?#iefix');
    src: url('${r}/Calibre-RWeb-RegularItalic.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-RegularItalic.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-RegularItalic.woff') format('woff');
  }

  /* medium */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 500;
    font-style: normal;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-Medium.eot?#iefix');
    src: url('${r}/Calibre-RWeb-Medium.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-Medium.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-Medium.woff') format('woff');
  }

  /* medium italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 500;
    font-style: italic;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-MediumItalic.eot?#iefix');
    src: url('${r}/Calibre-RWeb-MediumItalic.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-MediumItalic.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-MediumItalic.woff') format('woff');
  }

  /* semibold */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 600;
    font-style: normal;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-Semibold.eot?#iefix');
    src: url('${r}/Calibre-RWeb-Semibold.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-Semibold.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-Semibold.woff') format('woff');
  }

  /* semibold italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 600;
    font-style: italic;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-SemiboldItalic.eot?#iefix');
    src: url('${r}/Calibre-RWeb-SemiboldItalic.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-SemiboldItalic.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-SemiboldItalic.woff') format('woff');
  }

  /* bold */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 700;
    font-style: normal;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-Bold.eot?#iefix');
    src: url('${r}/Calibre-RWeb-Bold.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-Bold.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-Bold.woff') format('woff');
  }

  /* bold italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 700;
    font-style: italic;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-BoldItalic.eot?#iefix');
    src: url('${r}/Calibre-RWeb-BoldItalic.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-BoldItalic.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-BoldItalic.woff') format('woff');
  }

  /* black */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 800;
    font-style: normal;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-Black.eot?#iefix');
    src: url('${r}/Calibre-RWeb-Black.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-Black.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-Black.woff') format('woff');
  }

  /* black italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 800;
    font-style: italic;

    font-display: fallback;
    src: url('${r}/Calibre-RWeb-BlackItalic.eot?#iefix');
    src: url('${r}/Calibre-RWeb-BlackItalic.eot?#iefix') format('eot'),
      url('${r}/Calibre-RWeb-BlackItalic.woff2') format('woff2'),
      url('${r}/Calibre-RWeb-BlackItalic.woff') format('woff');
  }
`}
`;
export {
  At as B,
  ht as D,
  Ft as E,
  zt as F,
  vt as H,
  wt as K,
  Rt as L,
  jt as M,
  _t as P,
  xt as Q,
  It as R,
  bt as T,
  Ct as U,
  $t as W,
  yt as X,
  Ot as _,
  Wt as a,
  Tt as b,
  gt as c,
  kt as e,
  Pt as i,
  mt as j,
  St as n,
  Et as r,
  pt as z
};
